import SvgIcon from '@mui/material/SvgIcon';
import React, { memo } from 'react';

import { petrol } from '../../../styles/mui/colors';

// Kastenwagen

/**
 * @param {import('@mui/material/SvgIcon').SvgIconProps} props
 * @returns {React.ReactNode}
 */
const IconVehiclesComponent = ({ color = petrol.main, ...rest }) => {
  return (
    <SvgIcon sx={{ color }} {...rest} fontSize="large" viewBox="0 0 512 512">
      <svg
        fill="none"
        height="16"
        viewBox="0 0 24 16"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22.6349 12.7053V6.66411C22.6349 6.32239 22.5638 5.98443 22.4263 5.67168L20.9715 2.36418C20.6477 1.62805 19.9195 1.15283 19.1153 1.15283H3.00562C2.09952 1.15283 1.36499 1.88736 1.36499 2.79346V12.7053"
          fill="none"
          stroke="#0E3B43"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          d="M20.5308 12.7988H23.2969"
          fill="none"
          stroke="#0E3B43"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          d="M7.90894 12.7988H16.1298"
          fill="none"
          stroke="#0E3B43"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          d="M0.703125 12.7988H3.46927"
          fill="none"
          stroke="#0E3B43"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          d="M5.67923 14.8472C6.84895 14.8472 7.79719 13.899 7.79719 12.7293C7.79719 11.5596 6.84895 10.6113 5.67923 10.6113C4.50952 10.6113 3.56128 11.5596 3.56128 12.7293C3.56128 13.899 4.50952 14.8472 5.67923 14.8472Z"
          fill="none"
          stroke="#0E3B43"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          d="M18.3207 14.8472C19.4904 14.8472 20.4387 13.899 20.4387 12.7293C20.4387 11.5596 19.4904 10.6113 18.3207 10.6113C17.151 10.6113 16.2028 11.5596 16.2028 12.7293C16.2028 13.899 17.151 14.8472 18.3207 14.8472Z"
          fill="none"
          stroke="#0E3B43"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          d="M13.7649 3.97949H10.2351V12.7991H13.7649V3.97949Z"
          fill="none"
          stroke="#0E3B43"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          d="M7.19104 3.97949H1.36499V6.88218H7.19104V3.97949Z"
          fill="none"
          stroke="#0E3B43"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
        <path
          d="M21.5883 3.97949H16.809V6.88223H22.635"
          fill="none"
          stroke="#0E3B43"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        />
      </svg>
    </SvgIcon>
  );
};

IconVehiclesComponent.displayName = 'IconVehicles';

const IconVehicles = memo(IconVehiclesComponent);

export default IconVehicles;
